import { Injectable } from '@angular/core';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export enum PhxResponsiveBreakpoints {
  XS_MOBILE = '(max-width: 359px)',
  SM_MOBILE = '(max-width: 767px)',
  SM_TABLET = '(max-width: 1023px)',
  MD_TABLET = '(max-width: 1279px)',
  LG_DESKTOP = '(max-width: 1919px)',
  XL_DESKTOP = '(min-width: 1920px)',
}

@Injectable({ providedIn: 'root' })
export class PhxBreakpointObserverService {
  constructor(private _breakpointObserver: BreakpointObserver) {}

  public get xsMobile(): Observable<boolean> {
    return this._breakpointObserver
    .observe(PhxResponsiveBreakpoints.XS_MOBILE)
    .pipe(map((value: BreakpointState) => value.matches))
  }

  public get smMobile(): Observable<boolean> {
    return this._breakpointObserver
    .observe(PhxResponsiveBreakpoints.SM_MOBILE)
    .pipe(map((value: BreakpointState) => value.matches))
  }

  public get smTablet(): Observable<boolean> {
    return this._breakpointObserver
    .observe(PhxResponsiveBreakpoints.SM_TABLET)
    .pipe(map((value: BreakpointState) => value.matches))
  }

  public get mdTablet(): Observable<boolean> {
    return this._breakpointObserver
    .observe(PhxResponsiveBreakpoints.MD_TABLET)
    .pipe(map((value: BreakpointState) => value.matches))
  }

  public get lgDesktop(): Observable<boolean> {
    return this._breakpointObserver
    .observe(PhxResponsiveBreakpoints.LG_DESKTOP)
    .pipe(map((value: BreakpointState) => value.matches))
  }

  public get xlDesktop(): Observable<boolean> {
    return this._breakpointObserver
    .observe(PhxResponsiveBreakpoints.XL_DESKTOP)
    .pipe(map((value: BreakpointState) => value.matches))
  }

  public observe(value: PhxResponsiveBreakpoints | PhxResponsiveBreakpoints[]): Observable<BreakpointState> {
    return this._breakpointObserver.observe(value);
  }
}